<template>
    <div class="paas-table-expand">

        <Table slot="table" stripe border
               :data="rowData.orderProductList"
               :columns="tableColumns"
               :no-data-text="noDataText">
        </Table>
        <!--<Row v-for="(item, index) in rowData.orderProductList" class="expand-row" :key="item.id">
            <Col span="4">
                &nbsp; <img :src="item.image" width="120" height="120">
            </Col>
            <Col span="2">
                <p>{{item.name}}</p>
                <p>{{item.productAttr}}</p>
                <p>货号：{{item.productNo}}</p>
            </Col>
            <Col span="3">
                <span class="expand-value">{{ item.needPaymentAmount }}</span>
            </Col>
            <Col span="3">
                <span class="expand-value">{{ item.truePaymentAmount }}</span>
            </Col>
            <Col span="3">
                <p>优惠券抵扣：{{item.couponAmount}}</p>
                <p>积分抵扣：{{item.integralDeduct}}</p>
                <p>会员折扣：0</p>
            </Col>
            <Col span="3">
                <p>佣金：</p>
                <p>推广人：</p>
            </Col>
        </Row>-->
    </div>
</template>

<script>
    import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
    export default {
        name: "order-expand",
        components: {EnumShow},
        props: {
            rowData: Object
        },
        data(){
            return{
                tableColumns:[
                    {
                        type: 'index',
                        width: 50,
                    },
                    {
                        title: '商品图片',
                        key: 'image',
                        width:110,
                        render:(h,params)=>{
                           return h('img',{
                                attrs: {
                                    src: params.row.image,
                                },
                                style:{
                                    width:"80px",
                                    height:"80px",
                                }
                            })
                        }
                    },
                    {
                        title: 'SKU',
                        key: 'sku',
                        width:180,
                        render:(h,params)=>{
                            var mcOrderCode = params.row.infactOrderCode?params.row.infactOrderCode:"无";
                            return h('div',[
                                h('p', {},"sku："+params.row.sku),
                                h('p', {},"货号："+params.row.productNo),
                                h('p', {},"宝塔号："+mcOrderCode)
                            ])
                        }
                    },
                    {
                        title: '快递单号',
                        key: 'shippingSn',
                        width:120,
                        render:(h,params)=>{
                            let shippingName = params.row.shippingName?params.row.shippingName:"";
                            let shippingSn = params.row.shippingSn?params.row.shippingSn:"";
                            if(shippingName){
                                shippingName += "(";
                                if(shippingSn){
                                    shippingName += shippingSn;
                                }
                                shippingName += ")";
                            }
                            return h("div",[
                                h('p',{
                                    style:{
                                        fontSize:"12px",
                                        color:"black",
                                    }
                                },shippingName)
                            ])
                        }
                    },
                    {
                        title: '状态',
                        key: 'isDelete',
                        width:100,
                        render:(h,params)=>{
                            return h(EnumShow,{
                                style: {
                                    color:'red'
                                },
                                props:{
                                    enumGroupCode:'crmdict',
                                    enumCode:'buyProductStatus',
                                    value:params.row.isDelete
                                }
                            })
                        }
                    },
                    {
                        title: '商品介绍',
                        key: 'name',
                        render:(h,params)=>{
                            return h("div",[
                                h('p',{
                                    style:{
                                        fontSize:"12px",
                                        color:"black",
                                    }
                                },params.row.name)
                            ])
                        }
                    },
                    {
                        title: '属性',
                        key: 'productAttr',
                        width:100,
                    },
                    {
                        title: '数量',
                        key: 'purchaseNum',
                        width:50,
                    },
                    {
                        title: '应付金额',
                        key: 'truePaymentAmount',
                        width:80,
                    },
                    {
                        title: '实付金额',
                        key: 'truePaymentAmount',
                        width:80,
                    },
                    {
                        title: '费用详情',
                        key: 'truePaymentAmount',
                        width:130,
                        render:(h,params)=>{
                            var couponAmount = params.row.couponAmount?params.row.couponAmount:"0"
                            return h("div",[
                                h('p',{
                                    style:{
                                        fontSize:"12px",
                                        color:"black",
                                    }
                                },"优惠券抵扣："+couponAmount),
                                h('p',{
                                    style:{
                                        fontSize:"12px",
                                        color:"black",
                                    }
                                },"积分抵扣："+params.row.integralDeduct)
                            ])
                        }
                    },
                    {
                        title: '推广信息',
                        key: 'truePaymentAmount',
                        width:120,
                        render: (h, params) => {
                            return h("div",[
                                h('p',{
                                    style:{
                                        fontSize:"12px",
                                        color:"black",
                                    }
                                },"佣金："+params.row.commissionPrice),
                                h('p',{
                                    style:{
                                        fontSize:"12px",
                                        color:"black",
                                    }
                                },"推广人："+params.row.spreadName)
                            ])
                        }
                    },
                ]
            }
        },
        methods:{
        },
        created() {
        }
    }
</script>

<style scoped>

</style>